import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const TopBlock = styled(IndentContainer)<{ bgPath: string }>`
    width: 100%;
    background-image: url(${p => p.bgPath});
    background-position: right;
    background-size: cover;
    background-repeat: no-repeat;

    ${TextWrapper} {
        max-width: 300px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        background-image: url('/static/images/connect-domru/bg.mobile.png');

        ${TextWrapper} ${Paragraph4} {
            ${FONTS.S};
        }
    }
`;
